import { render, staticRenderFns } from "./TowelAdmin.vue?vue&type=template&id=db42a154"
import script from "./TowelAdmin.vue?vue&type=script&lang=js"
export * from "./TowelAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports